"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_SPINNER_SPEED_MULTIPLIER = exports.DEFAULT_SPINNER_COLOR = void 0;
const style_1 = __importDefault(require("style"));
exports.DEFAULT_SPINNER_COLOR = style_1.default.Color.Gray.S300;
exports.DEFAULT_SPINNER_SPEED_MULTIPLIER = 0.5;
